export enum FormAddressType {
  AUTO,
  MANUAL,
}
